<template>
  <b-card-text>
    <div class="d-flex justify-content-between">
      <h5>ПОДПИСИ СТОРОН</h5>
      <b-button
        @click="predprosmotr = !predprosmotr"
      >
        Предпросмотр
      </b-button>
    </div>

    <div v-if="predprosmotr" class="predprosmotr-card">
      <p class="text-center font-weight-bold">9. ПОДПИСИ СТОРОН</p>
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <div>КЛИЕНТ</div>
          <div>{{ docHistory['typ_dog'].short_pravovaya_form }} {{ docHistory['typ_dog'].full_pravovaya_form === 'Индивидуальный предприниматель' ? docHistory['typ_dog'].full_org_name_not_caps : ('«' + docHistory['typ_dog'].full_org_name + '»') }}</div>
          <div>{{ docHistory['typ_dog'].in_face_imen_padej_of_org }}</div>
          <div><br/></div>
          <div><br/></div>
          <div>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;{{ docHistory['typ_dog'].fio_of_face_short_of_org }}</div>
          <div>М.П.</div>
        </div>
        <div class="d-flex flex-column">
          <div>ПРЕДСТАВИТЕЛЬ</div>
          <div>ООО «ТАНАИС Брокер»</div>
          <div>Генеральный директор</div>
          <div><br/></div>
          <div><br/></div>
          <div>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Е.Э.Бородина</div>
          <div>М.П.</div>
        </div>
      </div>
    </div>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">Должность лица (именительный падеж):</label>
        <b-form-input
          :value="docHistory['typ_dog'].in_face_imen_padej_of_org"
          @input="docHistory['typ_dog'].in_face_imen_padej_of_org = capitalizeFirstLetter($event)"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">ФИО (И.О. Фамилия):</label>
        <b-form-input
          :value="docHistory['typ_dog'].fio_of_face_short_of_org"
          @input="docHistory['typ_dog'].fio_of_face_short_of_org = capitalizeFirstLetters($event)"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
  </b-card-text>
</template>

<script>
export default {
  data() {
    return {
      predprosmotr: false,
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    capitalizeFirstLetters(string) {
      return string.charAt(0).toUpperCase() + 
      string.charAt(1).toLowerCase() + 
      string.charAt(2).toUpperCase() + 
      string.charAt(3).toLowerCase() + 
      string.charAt(4).toUpperCase() + 
      string.slice(5).toLowerCase();
    },
  },
}
</script>

<style lang="scss" scoped>
  .small-label {
    font-size: 12px;
  }

  .predprosmotr-card {
    padding: 15px;
    margin: 20px 0;
    background: #cccccc59;
  }
</style>